import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import BEMHelper from '@ynap/bem-helper';
import Select from '@ynap/select';

const bem = new BEMHelper('DateSelect');

const days = [];
for (let i = 1; i <= 31; i++) days.push(i);

class DateSelect extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        value: PropTypes.string,
        className: PropTypes.string,
        months: PropTypes.arrayOf(PropTypes.string).isRequired,
        firstYear: PropTypes.number,
        lastYear: PropTypes.number,
        dayLabel: PropTypes.string,
        monthLabel: PropTypes.string,
        yearLabel: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
    };

    static defaultProps = {
        lastYear: new Date().getFullYear(),
    };

    constructor(props) {
        super();
        const { value } = props;
        const [day = '', month = '', year = ''] = value.split('-');
        this.state = { day, month, year };
    }

    handleChange = (event) => {
        const { onChange } = this.props;
        const { name, value } = event.target;
        this.setState({ [name]: value }, () => {
            const { day, month, year } = this.state;
            const date = day && month ? (year ? `${day}-${month}-${year}` : `${day}-${month}`) : '';
            onChange(date);
        });
    };

    handleFocus = (event) => {
        const { onFocus } = this.props;
        /* istanbul ignore else */
        if (event.relatedTarget !== this.dayRef && event.relatedTarget !== this.monthRef) {
            onFocus(event);
        }
    };

    handleBlur = (event) => {
        const { onBlur } = this.props;
        const { day, month, year } = this.state;
        /* istanbul ignore else */
        if (event.relatedTarget !== this.dayRef && event.relatedTarget !== this.monthRef) {
            onBlur(day && month ? (year ? `${day}-${month}-${year}` : `${day}-${month}`) : '');
        }
    };

    render() {
        const { className, months, dayLabel, monthLabel, yearLabel, id, firstYear, lastYear } = this.props;
        const { day, month, year } = this.state;

        const years = [];
        if (firstYear) {
            for (let i = firstYear; i <= lastYear; i++) years.push(i);
        }

        return (
            <div className={bem(null, null, className)}>
                <Select
                    name="day"
                    emptyLabel={dayLabel}
                    id={id}
                    value={day}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    selectRef={(node) => {
                        this.dayRef = node;
                    }}
                >
                    {days.map((dayOption) => {
                        switch (true) {
                            case dayOption === 31 && !['02', '04', '06', '09', '11'].includes(month):
                            case dayOption === 30 && month !== '02':
                            case dayOption < 30:
                                return (
                                    <option key={dayOption} value={dayOption < 10 ? `0${dayOption}` : `${dayOption}`}>
                                        {dayOption}
                                    </option>
                                );
                            default:
                                return null;
                        }
                    })}
                </Select>
                <Select
                    name="month"
                    emptyLabel={monthLabel}
                    id={id}
                    value={month}
                    onChange={this.handleChange}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    selectRef={(node) => {
                        this.monthRef = node;
                    }}
                >
                    {months.map((monthOption, index) => (
                        <option key={index} value={index + 1 < 10 ? `0${index + 1}` : `${index + 1}`}>
                            {monthOption}
                        </option>
                    ))}
                </Select>
                {firstYear ? (
                    <Select
                        name="year"
                        emptyLabel={yearLabel}
                        id={id}
                        value={year}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        selectRef={(node) => {
                            this.monthRef = node;
                        }}
                    >
                        {years.map((yearOption) => (
                            <option key={yearOption} value={yearOption}>
                                {yearOption}
                            </option>
                        ))}
                    </Select>
                ) : null}
            </div>
        );
    }
}

export default DateSelect;
